<template>
  <div class="box">
    <div class="label">{{ label }}</div>
    <div>
      <div class="label fleft">GAUCHE</div>
      <div class="label fright">DROITE</div>
    </div>
    <div class="inputrow" width="100">
      <div class="fleft">
        <span class="smart" @click="useSmart(1)">{{ smart }}</span>
        <input
          v-model="garment_left"
          class="garment"
          type="number"
          @keypress="isNumber($event)"
        />
      </div>
      <div class="fright">
        <span class="smart" @click="useSmart(2)">{{ smart }}</span>
        <input
          v-model="garment_right"
          class="garment"
          type="number"
          @keypress="isNumber($event)"
        />
      </div>
    </div>
    <div class="smart-measurements">S: {{ smartMeasurements }}</div>
  </div>
</template>
<style scoped>
.box {
  border-style: solid;
  border-color: black;
}

.label {
  font-size: 10;
  color: white;
  background-color: black;
  text-align: center;
}

.fleft {
  width: 50%;
  float: left;
  text-align: center;
}

.fright {
  width: 50%;
  float: right;
  text-align: center;
}

.smart {
  float: left;
  width: 30%;
  border-bottom: 1px solid grey;
  cursor: pointer;
  min-height: 23px;
}

.garment {
  float: right;
  width: 70%;
  text-align: center;
}

.smart-measurements {
  background-color: lightgray;
  align-items: center;
  padding: 1px 10px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
<script>
export default {
  name: 'GarmentConfig2',
  props: {
    label: {
      type: String,
      default: ''
    },
    smart: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    initGarmentLeft: {
      type: Number,
      default: 0
    },
    initGarmentRight: {
      type: Number,
      default: 0
    },
    smartMeasurements: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      garment_left: 0,
      garment_right: 0
    }
  },
  watch: {
    garment_left() {
      this.$emit('config', {
        name: `${this.name}l`,
        measure: this.garment_left
      })
    },
    garment_right() {
      this.$emit('config', {
        name: `${this.name}r`,
        measure: this.garment_right
      })
    }
  },
  mounted() {
    this.garment_left = parseFloat(this.initGarmentLeft)
    this.garment_right = parseFloat(this.initGarmentRight)
  },
  methods: {
    useSmart(side) {
      if (side === 1) {
        this.garment_left = parseFloat(this.smart)
      } else {
        this.garment_right = parseFloat(this.smart)
      }
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// GarmentConfig2.vue?0b791668